<section class="col-seleccion">
  <ticketing-stepper></ticketing-stepper>
  <fieldset>
    <tienda-selector-mas-entradas></tienda-selector-mas-entradas>
  </fieldset>
  <div class="btn-continuar-wrap">
    <!-- <a
      class="SiguienteButton"
      (click)="avanzar()"
      title="Siguiente"
      >{{ 'SIGUIENTE' | translate }}</a
    > -->
    <ticketing-siguiente-button></ticketing-siguiente-button>
  </div>
</section>
<ticketing-resumen-compra></ticketing-resumen-compra>
